import no_internet from "../assets/no-internet.png";
import _no_internet from "../assets/no-internet-white.png";
import { ThemeContext } from "../ThemeContext.js";
import { useContext } from "react";
const NoInternetPage = () => {
  const { theme } = useContext(ThemeContext);
  return (
    <div className="no-internet-page">
      <img
        alt="no-internet-image"
        src={theme === "dark" ? _no_internet : no_internet}
      />
      <h2 className="no-internet-header">
        Connect to the internet You're offline.
      </h2>
      <h3 style={{ color: "grey" }}>Check your connection.</h3>
    </div>
  );
};

export default NoInternetPage;
